import { defineType, defineField } from 'sanity';

export default defineType({
	name:   'aboutSection',
	title:  'About Wastic Page',
	type:   'document',
	fields: [
		defineField({
			name:   'heading',
			title:  'Heading',
			type:   'object',
			fields: [
				defineField({
					name:  'title',
					title: 'Title',
					type:  'localizedText',
				}),
				defineField({
					name:  'description',
					title: 'Description',
					type:  'localizedText',
				}),
			],
		}),
		defineField({
			name:   'impact',
			title:  'Our Impact',
			type:   'object',
			fields: [
				defineField({
					name:  'title',
					title: 'Title',
					type:  'localizedText',
				}),
				defineField({
					name:  'impacts',
					title: 'Impacts',
					type:  'array',
					of:    [
						{
							type:   'object',
							fields: [
								{
									name:  'heading',
									title: 'Heading',
									type:  'localizedText',
								}, {
									name:  'description',
									title: 'Description',
									type:  'localizedText',
								},
							],
							preview: {
								select: {
									title:    'heading.en',
									subtitle: 'description.en',
								},
							},
						},
					],
				}),
			],
		}),
		defineField({
			name:   'materials',
			title:  'Our Materials',
			type:   'object',
			fields: [
				defineField({
					name:  'title',
					title: 'Title',
					type:  'localizedText',
				}),
				defineField({
					name:  'materials',
					title: 'Materials',
					type:  'array',
					of:    [
						{
							type:   'object',
							fields: [
								defineField({
									name:  'heading',
									title: 'Heading',
									type:  'localizedText',
								}),
								defineField({
									name:  'description',
									title: 'Description',
									type:  'localizedText',
								}),
								defineField({
									name:    'image',
									title:   'Image',
									type:    'image',
									options: { hotspot: true },
								}),
							],
							preview: {
								select: {
									title:    'heading.en',
									subtitle: 'description.en',
								},
							},
						},
					],
				}),
			],
		}),
	],
	preview: { prepare: () => ({ title: 'About Wastic Page' }) },
});